import { SwapSkeleton } from './components/SwapSkeleton'
import { useSwap } from './logic/useSwap'
import { SuccessView } from './views/SuccessView'
import { SwapView } from './views/SwapView'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { withSuspense } from '@/ui/utils/withSuspense'

function SwapContainer() {
  const swap = useSwap()

  if (swap.pageStatus.state === 'success') {
    return <SuccessView {...swap.formValues} restartSwap={swap.pageStatus.restartSwap} />
  }

  return <SwapView {...swap} />
}

// @note: forces form to reset when network or account changes
function SwapContainerWithKey() {
  const { chainId, account } = useConnectedAddress({ throwOnNotConnected: false })
  return <SwapContainer key={`${chainId}-${account}`} />
}

// TODO: Add SwapSkeleton when implemented
const SwapContainerWithSuspense = withSuspense(SwapContainerWithKey, SwapSkeleton)

export { SwapContainerWithSuspense as SwapContainer }
